import React from 'react';
import { CheckIcon, SearchIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { teamMembers } from '../../data/conditions';
interface ConditionsToolbarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  assigneeFilter: string[];
  onAssigneeChange: (ids: string[]) => void;
  titleNotesAdded: boolean;
  onTitleNotesChange: (value: boolean) => void;
  selectedCount: number;
}
export function ConditionsToolbar({
  searchQuery,
  onSearchChange,
  assigneeFilter,
  onAssigneeChange,
  titleNotesAdded,
  onTitleNotesChange,
  selectedCount
}: ConditionsToolbarProps) {
  return <div className="flex flex-wrap items-center justify-between gap-3 border-y border-slate-200 bg-slate-50/70 px-5 py-2.5" data-id="element-195" data-mp="2nvbrfda8z5yz">
      <div className="flex min-w-0 flex-1 items-center gap-3" data-id="element-196" data-mp="2ivh0xaudwieg">
        <div className="relative w-full max-w-xl" data-id="element-197" data-mp="3gdz6aaynhorm">
          <SearchIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden="true" data-id="element-198" data-mp="3bm7g41jepl20" />
          <input type="search" value={searchQuery} onChange={e => onSearchChange(e.target.value)} placeholder="Search conditions by name or description" aria-label="Search conditions" className="w-full rounded-md border border-slate-300 bg-white py-1.5 pl-8 pr-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand" data-id="element-199" data-mp="2pqx2kgo5chad" />
        </div>
        {selectedCount > 0 && <span className="shrink-0 rounded-full bg-brand/10 px-2.5 py-0.5 text-xs font-semibold text-brand" data-id="element-200" data-mp="2aywe8nvcoi2q">
            {selectedCount} selected
          </span>}
      </div>

      <div className="flex flex-wrap items-center gap-4" data-id="element-201" data-mp="222nd94rq5beh">
        <div className="flex items-center gap-2" role="group" aria-label="Filter by assignee" data-id="element-202" data-mp="3rgipinvv323c">
          <span className="text-sm text-slate-600" data-id="element-203" data-mp="9fwdqwgqlqh">Assigned to</span>
          <ul className="flex items-center gap-1" data-id="element-204" data-mp="3uxerlo9z2uti">
            {teamMembers.map(m => {
            const active = assigneeFilter.includes(m.id);
            const dimmed = assigneeFilter.length > 0 && !active;
            return <li key={m.id} className="group/avatar relative" data-id="element-205" data-mp="3l00g832wow82">
                  <button type="button" aria-pressed={active} aria-label={`${m.name}, ${m.role}`} onClick={() => onAssigneeChange(active ? assigneeFilter.filter(id => id !== m.id) : [...assigneeFilter, m.id])} className={`relative block rounded-full transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 ${active ? 'ring-2 ring-brand ring-offset-2 ring-offset-slate-50' : ''} ${dimmed ? 'opacity-40 grayscale hover:opacity-80 hover:grayscale-0' : 'hover:-translate-y-0.5'}`} data-id="element-206" data-mp="3g0ns7f0atj3w">
                    <Avatar member={m} data-id="element-207" data-mp="17s97rlp385ed" />
                    {active && <span className="absolute -bottom-0.5 -right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-brand ring-2 ring-white" data-id="element-208" data-mp="17ulppyuuifrf">
                        <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-209" data-mp="1hrqem6g2spbx" />
                      </span>}
                  </button>
                  <span role="tooltip" className="pointer-events-none absolute left-1/2 top-full z-20 mt-1.5 -translate-x-1/2 whitespace-nowrap rounded bg-slate-900 px-2 py-1 text-[11px] font-medium text-white opacity-0 transition-opacity group-hover/avatar:opacity-100" data-id="element-210" data-mp="1qr52qz8rsnt9">
                    {m.name} · {m.role}
                  </span>
                </li>;
          })}
          </ul>
          {assigneeFilter.length > 0 && <button type="button" onClick={() => onAssigneeChange([])} className="rounded px-1 text-xs font-medium text-brand hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-211" data-mp="376hhb8142pe1">
              Clear
            </button>}
        </div>
        <label className="flex cursor-pointer items-center gap-2 text-sm text-slate-600" data-id="element-212" data-mp="3byivizhuaq6p">
          <input type="checkbox" checked={titleNotesAdded} onChange={e => onTitleNotesChange(e.target.checked)} className="h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand" data-id="element-213" data-mp="2o8y7i26tx2qk" />
          Title notes added
        </label>
      </div>
    </div>;
}